var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:"list list-" + _vm.$parent.model},_vm._l((_vm.$parent.items.data),function(item){return _c('router-link',{key:item.id,class:"list-" + _vm.$parent.model + "_item",attrs:{"tag":"li","to":_vm.$parent.getOpenLink(null, item.id)}},[_c('h2',{staticClass:"h6"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('br')])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }